import type { GetCards200CardsItem } from './getCards200CardsItem';

export type GetCards200 = {
  cards?: GetCards200CardsItem[];
  message?: string;
  success: boolean;
};
